<script lang="ts">
  // Brand marks come from simple-icons, not lucide: lucide dropped its brand
  // icons in v1, and these are trademarks with fixed artwork — an
  // approximated outline is not the mark, and a hand-pasted path silently
  // rots when a network rebrands (X already did once).
  //
  // Imported one file at a time rather than from the package root: the root
  // barrel pulls in all ~3,000 icon components for the compiler to walk, and
  // only the few in ICONS ever render. LinkedIn is the exception: simple-icons
  // removed its mark at LinkedIn's request, so it ships as a local component.
  import SiInstagram from "@icons-pack/svelte-simple-icons/icons/SiInstagram"
  import SiTiktok from "@icons-pack/svelte-simple-icons/icons/SiTiktok"
  import SiX from "@icons-pack/svelte-simple-icons/icons/SiX"
  import SiYoutube from "@icons-pack/svelte-simple-icons/icons/SiYoutube"

  import LinkedinMark from "@/components/icons/linkedin-mark.svelte"
  import { SOCIAL_PROFILES, type SocialKey } from "@/lib/brand-links"

  // One mark per key in config/brand_links.json; `satisfies` makes a network
  // added to SOCIAL_KEYS without a mark here a svelte-check error, not a
  // footer that crashes on an undefined component.
  const ICONS = {
    instagram: SiInstagram,
    tiktok: SiTiktok,
    x: SiX,
    linkedin: LinkedinMark,
    youtube: SiYoutube,
  } satisfies Record<SocialKey, unknown>
</script>

<!-- Muted like the footer's text links, not in each network's own colour:
     a row of saturated brand marks would outweigh every link around them.
     The mark inherits the anchor's ink via the component's `currentColor`
     default, so one hover rule covers them all. -->
<div class="flex items-center gap-4">
  {#each SOCIAL_PROFILES as profile (profile.key)}
    {@const Icon = ICONS[profile.key]}
    <a
      href={profile.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={profile.name}
      class="text-[#706f6c] transition-colors hover:text-[#1b1b18] dark:text-[#A1A09A] dark:hover:text-[#EDEDEC]"
    >
      <!-- The anchor's aria-label is the accessible name; hiding the svg
           stops its built-in <title> announcing the network a second time. -->
      <Icon size={18} title={profile.name} aria-hidden="true" />
    </a>
  {/each}
</div>
